import { StyleSheet, View } from 'react-native';

import { getName } from '@pletly/shared';
import { spacing } from '@pletly/ui';
import { UserAvatar } from '%components';
import { useLoggedUser } from '%context/LoggedUser';
import { MentionInput } from '%components/Mentions/MentionInput';
import { Props } from './types';
import { SendButton } from './SendButton';

export const CommentInput = ({ onSubmit, submitDisabled, style, ...inputProps }: Props) => {
	const user = useLoggedUser();

	return (
		<View style={styles.root}>
			<UserAvatar size={32} username={getName(user)} src={user.photoUrl} />
			<MentionInput
				{...inputProps}
				onSubmitEditing={onSubmit}
				accessoryRight={<SendButton onPress={onSubmit} disabled={submitDisabled} />}
				style={[styles.input, style]}
			/>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		gap: spacing(2),
		alignItems: 'center',
	},
	input: {
		flex: 1,
		borderWidth: 1,
	},
});
